import { Link2, Loader2, RefreshCw, AlertCircle, CheckCircle2 } from 'lucide-react';
import { useMemedIntegration } from '@/hooks/useMemedIntegration';
import { Button } from '@medikei/ui';
import { Badge } from '@medikei/ui';

export function MemedIntegrationStatus() {
  const { status, isLoading, link, isLinking } = useMemedIntegration();

  if (isLoading) {
    return (
      <div className="rounded-xl bg-blue-50 border border-blue-200 p-6">
        <div className="flex items-center gap-3">
          <Loader2 className="h-5 w-5 text-blue-600 animate-spin" />
          <span className="text-blue-700">Carregando status da integração...</span>
        </div>
      </div>
    );
  }

  if (!status?.isLinked || status.syncStatus === 'NOT_LINKED') {
    return (
      <div className="rounded-xl bg-yellow-50 border border-yellow-200 p-6">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5 shrink-0" />
            <div>
              <div className="flex items-center gap-2">
                <h3 className="font-semibold text-yellow-800">Conta não vinculada</h3>
                <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-blue-100 text-blue-800 border border-blue-200">
                  Modo Homologação (Sandbox)
                </span>
              </div>
              <p className="text-sm text-yellow-700 mt-1 leading-relaxed">
                Vincule sua conta da Memed para emitir receitas com catálogo Anvisa em ambiente de testes.
              </p>
              {status?.lastError && (
                <div className="mt-2 p-2.5 rounded-lg bg-red-100/80 border border-red-200 text-xs text-red-800 font-mono">
                  <strong>Detalhe retornado:</strong> {status.lastError}
                </div>
              )}
            </div>
          </div>
          <Button onClick={() => link()} disabled={isLinking} size="sm" className="shrink-0">
            {isLinking ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Vinculando...
              </>
            ) : (
              <>
                <Link2 className="h-4 w-4 mr-2" />
                Vincular à Memed
              </>
            )}
          </Button>
        </div>
      </div>
    );
  }

  if (status.syncStatus === 'SYNCING' || status.syncStatus === 'PENDING') {
    return (
      <div className="rounded-xl bg-blue-50 border border-blue-200 p-6">
        <div className="flex items-center gap-3">
          <Loader2 className="h-5 w-5 text-blue-600 animate-spin" />
          <span className="text-blue-700 font-medium">Sincronizando com a Memed...</span>
        </div>
      </div>
    );
  }

  if (status.syncStatus === 'FAILED') {
    return (
      <div className="rounded-xl bg-red-50 border border-red-200 p-6">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-red-600 mt-0.5" />
            <div>
              <h3 className="font-semibold text-red-800">Falha na sincronização</h3>
              <p className="text-sm text-red-700 mt-1">
                {status.lastError || 'Ocorreu um erro ao sincronizar com a Memed.'}
              </p>
            </div>
          </div>
          <Button onClick={() => link()} variant="outline" size="sm">
            <RefreshCw className="h-4 w-4 mr-2" />
            Tentar novamente
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl bg-green-50 border border-green-200 p-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          <CheckCircle2 className="h-5 w-5 text-green-600 mt-0.5" />
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-green-800">Conta Vinculada</h3>
              <Badge variant="success">Ativo</Badge>
            </div>
            <div className="mt-3 space-y-2 text-sm">
              {status.prescriberId && (
                <div className="flex items-center gap-2">
                  <span className="text-green-700">Prescritor:</span>
                  <span className="font-mono text-xs bg-green-100 px-2 py-0.5 rounded">
                    {status.prescriberId}
                  </span>
                </div>
              )}
              {status.lastSyncAt && (
                <p className="text-green-700">
                  Última sincronização: {new Date(status.lastSyncAt).toLocaleString('pt-BR')}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
